import styled from 'styled-components';

export const addGstPageHeader = styled.div(
  props => `
    display:flex;
    padding:16px;
    background-color:#FFF;
    .pageHeaderTxt{
      font-size:16px;
            line-height:20px;
            font-weight:700;
    }
    .pageHeaderSubTxt{
      font-size:12px;
      line-height:16px;
      color:#4a4a4a;
      margin-top:4px;
    }
  `,
);

export const AddGstPageContentWrap = styled.div(
  props => `
    background:#f2f2f2;
    padding:16px 16px 100px 16px;
    .error {
      color: red;
    }
    .success {
      color: green;
    }
    .appendTop {
      margin-top: 20px;
    }
    .checkboxClass {
      display: flex;
      gap: 4px;
      margin: 20px 0px 0px 10px;
    }
  `,
);

export const gstModlInputWrap = styled.div(
  props => `
        margin:${props.margin};
        flex:${props.flex};
        .inputMdlLabel{
            font-size:14px;
            line-height:20px;
            font-weight:900;
        }

        .dropdownClass {
          padding: 14px 12px;
          border-radius: 8px;
          outline: 0;
          border: 1px solid #D1D1D1;
          width: 100%;
          margin-top: 10px;
        }

        .error {
          color: red;
        }
    `,
);

export const gstModlInput = styled.input(
  props => `
        margin:${props.margin};
        width:${props.width};
        border:${props.border};
        padding:15px 12px;
        border-radius:8px;
        border: none;
        margin-top: 10px;
        outline:0;
    `,
);

export const gstModalCtaMob = styled.button(
  props => `
        width:${props.width};
        background-color:${props.backgroundColor};
        border-radius:8px;
        color:${props.color};
        border:unset;
        font-size:14px;
        line-height:20px;
        font-weight:900;
        text-transform:uppercase;
        padding:10px 0px;
        margin-top:40px;
    `,
);

export const gstModalCtaLoader = styled.div(
  props => `
    display: flex;
    justify-content: center;
    `,
);
